import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueMqtt from "vue-mqtt";
//import "leaflet/dist/leaflet.js";
//import "leaflet/dist/leaflet.css";

Vue.config.productionTip = false;
let opt = {
  clientId: "dashboard-redux-" + Date.now(),
  username: "aeris_public",
  password: "aeris_public"
};
Vue.use(VueMqtt, "wss://mqtt.eurec4a.eu:9002/mqtt", opt);

new Vue({
  router,
  store,
  vuetify,
  VueMqtt,
  render: h => h(App)
}).$mount("#app");
